import { Filters, FiltersFormData } from '../model/filterTypes';

export const DEFAULT_FILTERS: Filters = {
  revisionStatus: '',
  type: '',
  elaborationDate: null,
  approvalDate: null,
  effectiveDate: null,
  validFrom: null,
  validUntil: null,
  requestDate: null,
  revision: 0,
  user: '',
  branchId: 0,
  hasTraining: null,
  status: '',
  stage: '',
  distribution: '',
  format: '',
  validityDate: null,
  physicalLocation: '',
  isExternal: null,
  elaboratedBy: '',
  approvedBy: '',
  verifiedBy: '',
  verificationDate: null,
  documentType: '',
};

export const DEFAULT_FILTERS_FORM_DATA: FiltersFormData = {
  ...DEFAULT_FILTERS,
  revision: 0,
  elaborationApproval: '',
};

// ==================== ENTITIES ====================

export type EntityType = 'documento' | 'filial' | 'cargo' | 'registro';

export interface EntityConfig {
  plural: string;
  noneFoundMessage: string;
}

export const ENTITY_CONFIGS: Record<EntityType, EntityConfig> = {
  documento: {
    plural: 'documentos',
    noneFoundMessage: 'Nenhum documento encontrado',
  },
  filial: {
    plural: 'filiais',
    noneFoundMessage: 'Nenhuma filial encontrada',
  },
  cargo: {
    plural: 'cargos',
    noneFoundMessage: 'Nenhum cargo encontrado',
  },
  registro: {
    plural: 'registros',
    noneFoundMessage: 'Nenhum registro encontrado',
  },
} as const;

export const DEFAULT_ENTITY: EntityType = 'documento';

export function isValidEntityType(value: unknown): value is EntityType {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(ENTITY_CONFIGS, value);
}

// ==================== LISTING OPTIONS ====================

export const STATUS_MAPPING: Record<string, string> = {
  APPROVED: 'vigente',
  PENDING_APPROVAL: 'vigente',
  FAILED_APPROVAL: 'obsoleto',
  OBSOLETE: 'obsoleto',
  ARCHIVED: 'arquivado',
};

export const STATUS_OPTIONS = [
  { id: 'vigente', name: 'Vigente' },
  { id: 'obsoleto', name: 'Obsoleto' },
];

export const KEBAB_OPTIONS = [
  { id: 'historico', name: 'Histórico' },
  { id: 'treinamento', name: 'Treinamento' },
  { id: 'controle', name: 'Controle' },
];

export const STAGE_OPTIONS = [
  { id: 'in_progress', name: 'Em andamento' },
  { id: 'finish', name: 'Concluído' },
  { id: 'waiting_IP', name: 'Aguardando IP' },
  { id: 'waiting_AE', name: 'Aguardando AE' },
];

export const ORDER_OPTIONS = [
  { label: 'Arquivo mais recente', sort: 'effectiveDate', order: 'desc' },
  { label: 'Arquivo mais antigo', sort: 'effectiveDate', order: 'asc' },
  { label: 'Ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Ordem alfabética decrescente', sort: 'name', order: 'desc' },
  { label: 'Do menor para o maior', sort: 'revision', order: 'asc' },
  { label: 'Do maior para o menor', sort: 'revision', order: 'desc' },
];

export const DOCUMENT_TYPE_ORDER_OPTIONS = [
  { label: 'Arquivo mais recente', sort: 'effectiveDate', order: 'desc' },
  { label: 'Arquivo mais antigo', sort: 'effectiveDate', order: 'asc' },
  { label: 'Ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Ordem alfabética decrescente', sort: 'name', order: 'desc' },
  { label: 'Maior número de revisões', sort: 'revision', order: 'desc' },
  { label: 'Menor número de revisões', sort: 'revision', order: 'asc' },
  { label: 'Do menor para o maior', sort: 'prefix', order: 'asc' },
  { label: 'Do maior para o menor', sort: 'prefix', order: 'desc' },
];
